import React, { useState, KeyboardEvent } from 'react';
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

interface SkillsInputProps {
  skills: string[];
  onChange: (skills: string[]) => void;
}

const SkillsInput = ({ skills, onChange }: SkillsInputProps) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === 'Enter' || e.key === ',') && inputValue.trim()) {
      e.preventDefault();
      if (!skills.includes(inputValue.trim())) {
        onChange([...skills, inputValue.trim()]);
      }
      setInputValue('');
    } else if (e.key === 'Backspace' && !inputValue && skills.length > 0) {
      onChange(skills.slice(0, -1));
    }
  };

  const removeSkill = (indexToRemove: number) => {
    onChange(skills.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className="flex flex-wrap gap-2 p-2 border rounded-md min-h-[42px] focus-within:ring-1 focus-within:ring-primary">
      {skills.map((skill, index) => (
        <Badge
          key={index}
          variant="secondary"
          className="flex items-center gap-1 animate-fadeIn"
        >
          {skill}
          <button
            type="button"
            onClick={() => removeSkill(index)}
            className="ml-1 hover:text-destructive focus:outline-none"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      <Input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className="flex-1 border-0 focus-visible:ring-0 min-w-[120px]"
        placeholder={skills.length === 0 ? "Type a skill and press Enter" : "Add more skills..."}
      />
    </div>
  );
};

export default SkillsInput;